module.exports = __webpack_public_path__ + "img/logo-default.1de71484.png";